module.exports = __webpack_public_path__ + "media/images/recruitment/top-products-image-3e6faec76c4ac347a2d2065922cbfddd.jpg";